/** @jsxImportSource @emotion/react */
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { PUBLIC_ASSETS_BASE_URL } from '@app/app-constants'
import { Tooltip } from '@app/components/Atoms/Tooltip/Tooltip'
import {
  containerInnerLeft,
  containerInnerRight,
  containerLeftScroll,
  containerRightScroll,
  footer,
  footerText,
  loginWrapper,
  logo,
  rexContainerWrapper,
  socialLinks,
} from './RexContainer.style'

const RexContainer = ({
  children,
  content,
  bgColor,
}: {
  children: React.ReactNode
  content: React.ReactNode
  bgColor?: string
}) => {
  const theme = useTheme()

  return (
    <Box css={rexContainerWrapper({ theme })}>
      <Box css={containerLeftScroll({ theme })}>
        <Box css={containerInnerLeft({ theme })}>
          <Box css={loginWrapper}>{children}</Box>
        </Box>
      </Box>
      <Box css={containerRightScroll({ theme })}>
        <Box css={containerInnerRight({ theme, bgColor: bgColor ?? theme.palette.primary.main })}>
          <Box component="header"></Box>
          {content}
          <Box component="footer" css={footer({ theme })}>
            <Box css={socialLinks({ theme, bgColor: bgColor ?? theme.palette.primary.main })}>
              <Typography
                variant="h6"
                css={footerText({ theme, bgColor: bgColor ?? theme.palette.primary.main })}
              >
                Find us at
              </Typography>
              <Tooltip title="LinkedIn">
                <a
                  href="https://www.linkedin.com/company/urban-intelligence-nz/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <LinkedInIcon />
                </a>
              </Tooltip>
            </Box>
            <Box component="header">
              <a href="https://resilience-explorer.org/" target="_blank" rel="noreferrer">
                {bgColor ? (
                  <Box
                    component="img"
                    src={`${PUBLIC_ASSETS_BASE_URL}/images/shared/new_RexLogo_Full_for_light_bg.png`}
                    css={logo}
                  />
                ) : (
                  <Box
                    component="img"
                    src={`${PUBLIC_ASSETS_BASE_URL}/images/shared/new_RexLogoFull.svg`}
                    css={logo}
                  />
                )}
              </a>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default RexContainer
